import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Alteration from '../../components/user/Alteration';
export default {
  components: {
    Alteration: Alteration
  },
  data: function data() {
    return {
      tenantInfo: {}
    };
  },
  created: function created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
  methods: {}
};